export function initializeScrolTop() {
  document.getElementsByTagName('html')[0].scrollTop = 0;
  document.getElementsByTagName('body')[0].scrollTop = 0;
  document.getElementsByClassName('scrollable')[0].scrollTop = 0;
}
